import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const languages = [
    { key: "en", value: "ENG", ISO: "en-US" },
    { key: "ru", value: "РУС", ISO: "ru-RU" },
    { key: "uk", value: "УКР", ISO: "uk-UA" }
];

export function getIso(language) {
    return languages.find(x => x.key === language).ISO;
}

i18n.use(LanguageDetector).use(initReactI18next).init({
        resources: {
            en: {
                translations: {
                    "PagesNames.Cards": "Cards",
                    "PagesNames.Operations": "Operations",
                    "PagesNames.Devices": "Devices",
                    "PagesNames.Tanks": "Tanks",
                    "Header.LogoutText": "Logout",
                    "Table.Empty": "The list is empty",
                    "Table.saveButton": "Save",
                    "Table.cancelButton": "Cancel",
                    "Cards.cardNumber": "Card Number",
                    "Cards.cardNumberExternal": "Physical Card Number",
                    "Cards.userName": "User Name",
                    "Cards.car": "Car",
                    "Cards.description": "Description",
                    "Devices.deviceImei": "Device Imei",
                    "Devices.name": "Device Name",
                    "Devices.description": "Description",
                    "Devices.protocolType": "Protocol Type",
                    "Devices.deviceType": "Device Type",
                    "Devices.isActive": "Is active",
                    "Devices.deviceIoSettings.volumeCountIoId": "Volume count IO id",
                    "Devices.deviceIoSettings.volumeRatio": "Ratio",
                    "Devices.deviceIoSettings.valveIoId": "Valve IO id",
                    "Devices.deviceIoSettings.userKeyIoId": "User Key IO id",
                    "Devices.withLevelMetterText": "With level metter",
                    "Devices.levelMetterSettings.levelMeterInstallHeight": "Level metter installation height",
                    "Devices.levelMetterSettings.temperatureIoId": "Temperature IO ID",
                    "Devices.levelMetterSettings.temperatureRatio": "Temperature ratio",
                    "Devices.levelMetterSettings.temperatureDelta": "Temperature delta",
                    "Devices.levelMetterSettings.waterLevelMetterIoId": "Watter level metter IO ID",
                    "Devices.levelMetterSettings.watterLevelMetterRatio": "Watter level metter ratio",
                    "Devices.levelMetterSettings.waterLevelMetterDelta": "Watter level metter delta",
                    "Devices.levelMetterSettings.productLevelMetterIoId": "Product level metter IO ID",
                    "Devices.levelMetterSettings.productLevelMetterRatio": "Product level metter ratio",
                    "Devices.levelMetterSettings.productLevelMetterDelta": "Product level metter delta",
                    "Devices.levelMetterSettings.defaultDensity": "Default density",
                    "Devices.levelMetterSettings.densityIoId": "Density IO ID",
                    "Devices.levelMetterSettings.densityRatio": "Density ratio",
                    "Devices.levelMetterSettings.densityDelta": "Density delta",
                    "Operations.cardNumber": "Card number",
                    "Operations.userName": "Driver Name",
                    "Operations.operationTs": "Operation time",
                    "Operations.startOperationTs": "Start operation time",
                    "Operations.endOperationTs": "Finish operation time",
                    "Operations.deviceImei": "Device Imei",
                    "Operations.rawVolumeData": "Raw volume",
                    "Operations.volume": "Volume",
                    "Operations.tankBalance": "Tank balance",
                    "UserManagement.userName": "User Login",
                    "UserManagement.firstName": "Name",
                    "UserManagement.secondName": "Surname",
                    "UserManagement.email": "Email",
                    "UserManagement.isActive": "Is Active",
                    "UserManagement.roleName": "Role Name",
                    "Tanks.tankName": "Tank",
                    "Tanks.volume": "Volume",
                    "Tanks.balance": "Balance",
                    "Tanks.minLevel": "Min volume",
                    "Tanks.maxLevel": "Max volume",
                    "Tanks.Details.maxLevel": "Tank volume",
                    "Tanks.Details.calculatedVolume": "Calculated volume",
                    "Tanks.fuelType": "Fuel type",
                    "Tanks.areaName": "Area",
                    "Tanks.areaDescription": "Description",
                    "Tanks.department": "Department",
                    "Tanks.usedTankBalance": "Current balance",
                    "Tanks.graduations": "Graduations",
                    "TankOperation.tankName": "Tank",
                    "TankOperation.userName": "User name",
                    "TankOperation.fuelType": "Fuel type",
                    "TankOperation.provider": "Fuel provider",
                    "TankOperation.description": "Description",
                    "TankOperation.balance": "Delivered",
                    "TankOperation.deliveryDate": "Delivery date",
                    "TanksPagesNames.Tanks": "Tanks",
                    "TanksPagesNames.TankOperations": "Tanks operations",
                    "TanksPagesNames.TanksStateOperations": "Tanks state operations",
                    "TanksOperations.Filter.tankName": "Tank",
                    "TanksOperations.Filter.dateFrom": "From date:",
                    "TanksOperations.Filter.dateTo": "To date:",
                    "TankStateOperation.tankName": "Tank",
                    "TankStateOperation.watterLevelHeight": "Watter level (mm)",
                    "TankStateOperation.watterLevelVolume": "Watter level (l)",
                    "TankStateOperation.productLevelHeight": "Product level (mm)",
                    "TankStateOperation.productLevelVolume": "Product level (l)",
                    "TankStateOperation.temperature": "Temperature",
                    "TankStateOperation.density": "Density",
                    "TankStateOperation.weight": "Weight",
                    "TankStateOperation.packageTs": "Update time",
                    "TankStateOperation.densityUnit": "t/m3",
                    "TankStateOperation.weightUnit": "t",
                    "Operations.Filter.userName": "User name",
                    "Operations.Filter.dateFrom": "From date:",
                    "Operations.Filter.dateTo": "To date:",
                    "TankStateOperation.Filter.tankName": "Tank",
                    "TankStateOperation.Filter.dateFrom": "From date:",
                    "TankStateOperation.Filter.dateTo": "To date:",
                    "ExtendedIo.ioType": "IO type",
                    "ExtendedIo.ioDataType": "Data type",
                    "ExtendedIo.ioAddress": "IO id",
                    "ExtendedIo.ratio": "Ratio",
                    "ExtendedIo.offset": "Offset",
                    "ExtendedIo.dataDelta": "Data delta",
                    "ExtendedIo.defaultValue": "Default value",
                    "ExtendedIo.ioDataAction": "Convert data action",
                    "ExtendedIo.ioDataActionParam": "Convert data action param",
                    "ExtendedIo.EditTankHeader": "Device Extended IOs",
                    "ExtendedIo.watterLevelHeightIoName": "Watter level height",
                    "ExtendedIo.watterLevelVolumeIoName": "Watter level volume",
                    "ExtendedIo.productLevelHeightIoName": "Product level heigth",
                    "ExtendedIo.producLevelVolumeIoName": "Product level volume",
                    "ExtendedIo.productLevelHeightIoQualityName": "Product level heigth IO quality",
                    "ExtendedIo.watterLevelHeightIoQualityName": "Watter level heigth IO quality",
                    "ExtendedIo.producLevelVolumeIoQualityName": "Product level volume IO quality",
                    "ExtendedIo.watterLevelVolumeIoQualityName": "Watter level volume IO quality",
                    "ExtendedIo.temperatureIoName": "Temperature",
                    "ExtendedIo.temperatureIoQualityName": "Temperature IO quality",
                    "ExtendedIo.densityIoName": "Density",
                    "ExtendedIo.densityIoQualityName": "Density quality",
                    "ExtendedIo.pressureIoName": "Pressure",
                    "ExtendedIo.pressureIoQualityName": "Pressure IO quality",
                    "ExtendedIo.weightIoName": "Weight",
                    "ExtendedIo.weightIoQualityName": "Weight IO quality"
                }
            },
            ru: {
                translations: {
                    "PagesNames.Cards": "Карты",
                    "PagesNames.Operations": "Операции",
                    "PagesNames.Devices": "Устройства",
                    "PagesNames.Tanks": "Резервуары",
                    "Header.LogoutText": "Вийти",
                    "Table.Empty": "Список пустой",
                    "Table.saveButton": "Сохранить",
                    "Table.cancelButton": "Отмена",
                    "Cards.cardNumber": "Номер карты",
                    "Cards.cardNumberExternal": "Физический номер карты",
                    "Cards.userName": "Имя водителя",
                    "Cards.car": "Машина",
                    "Cards.description": "Примечание",
                    "Devices.deviceImei": "Imei прибора",
                    "Devices.name": "Имя прибора",
                    "Devices.description": "Описание",
                    "Devices.protocolType": "Тип протокола",
                    "Devices.deviceType": "Тип устройства",
                    "Devices.isActive": "Активный",
                    "Devices.deviceIoSettings.volumeCountIoId": "Номер датчика обьема",
                    "Devices.deviceIoSettings.volumeRatio": "Коэффициент преобразования",
                    "Devices.deviceIoSettings.valveIoId": "Номер датчика клапана",
                    "Devices.deviceIoSettings.userKeyIoId": "Номер датчика чтения ключа",
                    "Devices.withLevelMetterText": "Установлен уровнемер",
                    "Devices.levelMetterSettings.levelMeterInstallHeight": "Высота установки уровнемера",
                    "Devices.levelMetterSettings.temperatureIoId": "Номер датчика температури",
                    "Devices.levelMetterSettings.temperatureRatio": "Коэфициент преобразования температури",
                    "Devices.levelMetterSettings.temperatureDelta": "Дэльта изменения температури",
                    "Devices.levelMetterSettings.waterLevelMetterIoId": "Номер датчика уровня воды",
                    "Devices.levelMetterSettings.watterLevelMetterRatio": "Коэфициент уровня воды",
                    "Devices.levelMetterSettings.waterLevelMetterDelta": "Дэльта изменения уровня воды",
                    "Devices.levelMetterSettings.productLevelMetterIoId": "Номер датчика уровня продукта",
                    "Devices.levelMetterSettings.productLevelMetterRatio": "Коэфициент уровня продукта",
                    "Devices.levelMetterSettings.productLevelMetterDelta": "Дэльта изменения уровня продукта",
                    "Devices.levelMetterSettings.defaultDensity": "Плотность продукта по умолчанию",
                    "Devices.levelMetterSettings.densityIoId": "Номер датчика плотности",
                    "Devices.levelMetterSettings.densityRatio": "Коэфициент преобразования плотности",
                    "Devices.levelMetterSettings.densityDelta": "Дэльта изменения плотности",
                    "Operations.cardNumber": "Номер карты",
                    "Operations.userName": "Имя водителя",
                    "Operations.operationTs": "Время операции",
                    "Operations.startOperationTs": "Время начала операции",
                    "Operations.endOperationTs": "Время окончания операции",
                    "Operations.deviceImei": "Имей устройства",
                    "Operations.rawVolumeData": "Необработаный обьем",
                    "Operations.volume": "Обьем",
                    "Operations.tankBalance": "Остаток в резервуаре",
                    "UserManagement.userName": "Логин пользователя",
                    "UserManagement.firstName": "Имя",
                    "UserManagement.secondName": "Фамилия",
                    "UserManagement.email": "Почта",
                    "UserManagement.isActive": "Активный",
                    "UserManagement.roleName": "Роль",
                    "Tanks.tankName": "Резервуар",
                    "Tanks.volume": "Обьем",
                    "Tanks.balance": "Остаток",
                    "Tanks.minLevel": "Минимальный обьем",
                    "Tanks.maxLevel": "Максимальный обьем",
                    "Tanks.fuelType": "Тип топлива",
                    "Tanks.areaName": "Площадка",
                    "Tanks.areaDescription": "Описание",
                    "Tanks.department": "Подразделение",
                    "Tanks.usedTankBalance": "Резервуар заполнен на",
                    "Tanks.graduations": "Градуировка",
                    "Tanks.Details.maxLevel": "Обьем резервуара",
                    "Tanks.Details.calculatedVolume": "Вычисленный остаток",
                    "TankOperation.tankName": "Резервуар",
                    "TankOperation.userName": "Имя пользователя",
                    "TankOperation.fuelType": "Тип топлива",
                    "TankOperation.provider": "Поставщик",
                    "TankOperation.description": "Коментарий",
                    "TankOperation.balance": "Отгружено",
                    "TankOperation.deliveryDate": "Время поставки",
                    "TanksPagesNames.Tanks": "Резервуары",
                    "TanksPagesNames.TankOperations": "Отгрузки по резервуарам",
                    "TanksPagesNames.TanksStateOperations": "Изменения состояния резервуаров",
                    "TanksOperations.Filter.tankName": "Резервуар",
                    "TanksOperations.Filter.dateFrom": "Дата с:",
                    "TanksOperations.Filter.dateTo": "Дата по:",
                    "TankStateOperation.tankName": "Имя резервуара",
                    "TankStateOperation.watterLevelHeight": "Уровень воды (мм)",
                    "TankStateOperation.watterLevelVolume": "Уровень воды (л)",
                    "TankStateOperation.productLevelHeight": "Уровень продукта (мм)",
                    "TankStateOperation.productLevelVolume": "Уровень продукта (л)",
                    "TankStateOperation.temperature": "Температура",
                    "TankStateOperation.density": "Плотность",
                    "TankStateOperation.weight": "Вес",
                    "TankStateOperation.packageTs": "Время обновления",
                    "TankStateOperation.densityUnit": "т/м3",
                    "TankStateOperation.weightUnit": "т",
                    "Operations.Filter.userName": "Имя водителя",
                    "Operations.Filter.dateFrom": "Дата с:",
                    "Operations.Filter.dateTo": "Дата по:",
                    "TankStateOperation.Filter.tankName": "Резервуар",
                    "TankStateOperation.Filter.dateFrom": "Дата с:",
                    "TankStateOperation.Filter.dateTo": "Дата по:",
                    "ExtendedIo.ioType": "Тип датчика",
                    "ExtendedIo.ioDataType": "Тип данных",
                    "ExtendedIo.ioAddress": "Адрес датчика",
                    "ExtendedIo.ratio": "Коэффициент",
                    "ExtendedIo.offset": "Смещение",
                    "ExtendedIo.dataDelta": "Дельта",
                    "ExtendedIo.defaultValue": "Значение по умолчанию",
                    "ExtendedIo.ioDataAction": "Действие конвертации",
                    "ExtendedIo.ioDataActionParam": "Параметр конвертации",
                    "ExtendedIo.EditTankHeader": "Дополнительные датчики",
                    "ExtendedIo.watterLevelHeightIoName": "Уровень высоты воды",
                    "ExtendedIo.watterLevelVolumeIoName": "Уровень обьема воды",
                    "ExtendedIo.productLevelHeightIoName": "Уровень высоты продукта",
                    "ExtendedIo.producLevelVolumeIoName": "Уровень обьема продукта",
                    "ExtendedIo.productLevelHeightIoQualityName": "Качество сигнала уровня высоты продукта",
                    "ExtendedIo.watterLevelHeightIoQualityName": "Качество сигнала уровня высоты воды",
                    "ExtendedIo.producLevelVolumeIoQualityName": "Качество сигнала уровня обьема продукта",
                    "ExtendedIo.watterLevelVolumeIoQualityName": "Качество сигнала уровня обьема воды",
                    "ExtendedIo.temperatureIoName": "Температура",
                    "ExtendedIo.temperatureIoQualityName": "Качество сигнала температуры",
                    "ExtendedIo.densityIoName": "Плотность",
                    "ExtendedIo.densityIoQualityName": "Качество сигнала плотности",
                    "ExtendedIo.pressureIoName": "Давление",
                    "ExtendedIo.pressureIoQualityName": "Качество сигнала давления",
                    "ExtendedIo.weightIoName": "Вес",
                    "ExtendedIo.weightIoQualityName": "Качество сигнала датчика веса"
                }                
            },
            uk: {
                translations: {
                    "PagesNames.Cards": "Карти",
                    "PagesNames.Operations": "Операції",
                    "PagesNames.Devices": "Прилади",
                    "PagesNames.Tanks": "Резервуари",
                    "Header.LogoutText": "Вийти",
                    "Table.Empty": "Список пустий",
                    "Table.saveButton": "Зберегти",
                    "Table.cancelButton": "Відміна",
                    "Cards.cardNumber": "Номер карти",
                    "Cards.cardNumberExternal": "Фізичний номер карти",
                    "Cards.userName": "Ім'я водія",
                    "Cards.car": "Авто",
                    "Cards.description": "Примітка",
                    "Devices.deviceImei": "Imei приладу",
                    "Devices.name": "Ім'я приладу",
                    "Devices.description": "Опис",
                    "Devices.protocolType": "Тип протоколу",
                    "Devices.deviceType": "Тип приладу",
                    "Devices.isActive": "Активний",
                    "Devices.deviceIoSettings.volumeCountIoId": "Номер датчику об'єму",
                    "Devices.deviceIoSettings.volumeRatio": "Коефіцієнт перетворення",
                    "Devices.deviceIoSettings.valveIoId": "Номер датчика клапану",
                    "Devices.deviceIoSettings.userKeyIoId": "Номер датчика читання ключа",
                    "Devices.withLevelMetterText": "Встановлений рівнемір",
                    "Devices.levelMetterSettings.levelMeterInstallHeight": "Висота установки рівнеміра",
                    "Devices.levelMetterSettings.temperatureIoId": "Номер датчика температури",
                    "Devices.levelMetterSettings.temperatureRatio": "Коефіцієнт перетворення температури",
                    "Devices.levelMetterSettings.temperatureDelta": "Дельта зміни температури",
                    "Devices.levelMetterSettings.waterLevelMetterIoId": "Номер датчику рівня води",
                    "Devices.levelMetterSettings.watterLevelMetterRatio": "Коефіцієнт рівня води",
                    "Devices.levelMetterSettings.waterLevelMetterDelta": "Дельта зміни рівня води",
                    "Devices.levelMetterSettings.productLevelMetterIoId": "Номер датчику рівня продукту",
                    "Devices.levelMetterSettings.productLevelMetterRatio": "Коефіцієнт рівня продукту",
                    "Devices.levelMetterSettings.productLevelMetterDelta": "Дельта зміни рівня продукту",
                    "Devices.levelMetterSettings.defaultDensity": "Щільність продукту за замовчуванням",
                    "Devices.levelMetterSettings.densityIoId": "Номер датчику щільності",
                    "Devices.levelMetterSettings.densityRatio": "Коефіцієнт перетворення щільності",
                    "Devices.levelMetterSettings.densityDelta": "Дельта зміни щільності",
                    "Operations.cardNumber": "Номер карти",
                    "Operations.userName": "Ім'я водія",
                    "Operations.operationTs": "Час операції",
                    "Operations.startOperationTs": "Час початку операції",
                    "Operations.endOperationTs": "Час закінчення операції",
                    "Operations.deviceImei": "Імей приладу",
                    "Operations.rawVolumeData": "Необроблений об'єм",
                    "Operations.volume": "Об'єм",
                    "Operations.tankBalance": "Залишок в резервуарі",
                    "UserManagement.userName": "Логін користувача",
                    "UserManagement.firstName": "Ім'я",
                    "UserManagement.secondName": "Прізвище",
                    "UserManagement.email": "Почта",
                    "UserManagement.isActive": "Активний",
                    "UserManagement.roleName": "Роль",
                    "Tanks.tankName": "Резервуар",
                    "Tanks.volume": "Об'єм",
                    "Tanks.balance": "Залишок",
                    "Tanks.minLevel": "Мінімальний об'єм",
                    "Tanks.maxLevel": "Максимальний об'єм",
                    "Tanks.fuelType": "Тип палива",
                    "Tanks.areaName": "Площадка",
                    "Tanks.areaDescription": "Опис",
                    "Tanks.department": "Підрозділ",
                    "Tanks.usedTankBalance": "Резервуар заповнений на",
                    "Tanks.graduations": "Градуювання",
                    "Tanks.Details.maxLevel": "Об'єм резервуара",
                    "Tanks.Details.calculatedVolume": "Розрахунковий залишок",
                    "TankOperation.tankName": "Резервуар",
                    "TankOperation.userName": "Ім'я користувача",
                    "TankOperation.fuelType": "Тип палива",
                    "TankOperation.provider": "Постачальник",
                    "TankOperation.description": "Коментар",
                    "TankOperation.balance": "Відвантажено",
                    "TankOperation.deliveryDate": "Час поставки",
                    "TanksPagesNames.Tanks": "Резервуари",
                    "TanksPagesNames.TankOperations": "Відвантаження по резервуарам",
                    "TanksPagesNames.TanksStateOperations": "Зміна стану резервуарів",
                    "TanksOperations.Filter.tankName": "Резервуар",
                    "TanksOperations.Filter.dateFrom": "Дата з:",
                    "TanksOperations.Filter.dateTo": "Дата по:",
                    "TankStateOperation.tankName": "Ім'я резервуару",
                    "TankStateOperation.watterLevelHeight": "Рівень води (мм)",
                    "TankStateOperation.watterLevelVolume": "Рівень води (л)",
                    "TankStateOperation.productLevelHeight": "Рівень продукту (мм)",
                    "TankStateOperation.productLevelVolume": "Рівень продукту (л)",
                    "TankStateOperation.temperature": "Температура",
                    "TankStateOperation.density": "Щільність",
                    "TankStateOperation.weight": "Вага",
                    "TankStateOperation.packageTs": "Час оновлення",
                    "TankStateOperation.densityUnit": "т/м3",
                    "TankStateOperation.weightUnit": "т",
                    "Operations.Filter.userName": "Ім'я водія",
                    "Operations.Filter.dateFrom": "Дата з:",
                    "Operations.Filter.dateTo": "Дата по:",
                    "TankStateOperation.Filter.tankName": "Резервуар",
                    "TankStateOperation.Filter.dateFrom": "Дата з:",
                    "TankStateOperation.Filter.dateTo": "Дата по:",
                    "ExtendedIo.ioType": "Тип датчика",
                    "ExtendedIo.ioDataType": "Тип данних",
                    "ExtendedIo.ioAddress": "Адреса датчика",
                    "ExtendedIo.ratio": "Коеффіцієнт",
                    "ExtendedIo.offset": "Зміщення",
                    "ExtendedIo.dataDelta": "Дельта",
                    "ExtendedIo.defaultValue": "Значення за замовчуванням",
                    "ExtendedIo.ioDataAction": "Дія конвертації",
                    "ExtendedIo.ioDataActionParam": "Параметр конвертації",
                    "ExtendedIo.EditTankHeader": "Додаткові датчики",
                    "ExtendedIo.watterLevelHeightIoName": "Рівень висоти води",
                    "ExtendedIo.watterLevelVolumeIoName": "Рівень об'єму води",
                    "ExtendedIo.productLevelHeightIoName": "Рівень висоти продукту",
                    "ExtendedIo.producLevelVolumeIoName": "Рівень об'єму продукту",
                    "ExtendedIo.productLevelHeightIoQualityName": "Якість сигналу рівня висоти продукту",
                    "ExtendedIo.watterLevelHeightIoQualityName": "Якість сигналу рівня висоти води",
                    "ExtendedIo.producLevelVolumeIoQualityName": "Якість сигналу рівня об'єму продукту",
                    "ExtendedIo.watterLevelVolumeIoQualityName": "Якість сигналу рівня об'єму води",
                    "ExtendedIo.temperatureIoName": "Температура",
                    "ExtendedIo.temperatureIoQualityName": "Якість сигналу температури",
                    "ExtendedIo.densityIoName": "Густина",
                    "ExtendedIo.densityIoQualityName": "Якість сигналу густини",
                    "ExtendedIo.pressureIoName": "Тиск",
                    "ExtendedIo.pressureIoQualityName": "Якість сигналу тиску",
                    "ExtendedIo.weightIoName": "Вага",
                    "ExtendedIo.weightIoQualityName": "Якість сигналу датчика ваги"
                }
            }
        },
    fallbackLng: "ru",
    debug: true,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
            }
            ,

    react: {
        wait: true
    },

    detection: { caches: ['localStorage'], lookupLocalStorage: 'i18nextLng'}

});

export default i18n;